import { render, staticRenderFns } from "./StepInventory.vue?vue&type=template&id=b2e8fa24"
import script from "./StepInventory.vue?vue&type=script&lang=js"
export * from "./StepInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports